export default {
    mounted(el) {
        let parent = el.parentNode
        
        parent.classList.add("has-preload")
        parent.classList.add("preload")
        
        setTimeout(() => {
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    el.src = el.dataset.src
                    parent.classList.remove("preload")
                    observer.disconnect()

                    setTimeout(() => {
                        parent.classList.remove("has-preload")
                    }, 400)
                }
            })

            observer.observe(el)
        }, 0)
    }
}
